import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { useLastLocation } from 'react-router-last-location';

import { isWhitelisted } from '../../hocs/Permissions';
import {
  getCurrentRolesList,
  isValidToken,
} from '../../redux/session/selectors';
import { AppState } from '../../redux/state';
import PrivateRoute from './PrivateRoute';

const AutorizedRroute = ({
  isAuthenticated,
  roles,
  currentRoles,
  ...props
}: AutorizedRrouteProps) => {
  const lastLocation = useLastLocation();
  const canActivate = isAuthenticated && isWhitelisted(currentRoles, roles);
  return (
    <PrivateRoute
      canActivate={canActivate}
      redirectTo={lastLocation || '/'}
      {...props}
    />
  );
};

interface AutorizedRrouteProps extends React.ComponentProps<typeof Route> {
  isAuthenticated: boolean;
  roles: string | string[];
  currentRoles: string[];
}

const mapStateToProps = (state: AppState) => ({
  currentRoles: getCurrentRolesList(state),
  isAuthenticated: isValidToken(state),
});

export default connect(mapStateToProps)(AutorizedRroute);
